import { Subject } from 'rxjs';

class Notify {
    static notifier = new Subject();

    static send = (data) => {
        Notify.notifier.next(data);
    }

    static listen = (cb) => {
        return Notify.notifier.subscribe((data) => cb(data));
    }

}

export default Notify;
